import { render, staticRenderFns } from "./TrixEdit.vue?vue&type=template&id=927e97ce&"
import script from "./TrixEdit.vue?vue&type=script&lang=js&"
export * from "./TrixEdit.vue?vue&type=script&lang=js&"
import style0 from "./TrixEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports